import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { TypingLabels } from '../../hooks/chat/typing';

/**
 * Who else is typing in the open conversation, between the thread and the
 * composer: the rider, quietly; another agent, as a warning, since two
 * agents answering the same rider collide.
 */
export function TypingIndicator({ rider, agents }: TypingLabels) {
  if (!rider && !agents) return null;
  return (
    <Box
      sx={{ px: 3, pb: 0.75, bgcolor: 'background.default' }}
      aria-live="polite"
      data-testid="typing-indicator"
    >
      {agents && (
        <Alert
          severity="warning"
          variant="outlined"
          sx={{ py: 0, mb: rider ? 0.5 : 0 }}
          data-testid="agent-typing"
        >
          {agents}
        </Alert>
      )}
      {rider && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontStyle: 'italic', display: 'block' }}
          data-testid="rider-typing"
        >
          {rider}
        </Typography>
      )}
    </Box>
  );
}
